"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordBVHStatusT = exports.RecordBVHStatus = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class RecordBVHStatus {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsRecordBVHStatus(bb, obj) {
        return (obj || new RecordBVHStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsRecordBVHStatus(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new RecordBVHStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    recording() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startRecordBVHStatus(builder) {
        builder.startObject(1);
    }
    static addRecording(builder, recording) {
        builder.addFieldInt8(0, +recording, +false);
    }
    static endRecordBVHStatus(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createRecordBVHStatus(builder, recording) {
        RecordBVHStatus.startRecordBVHStatus(builder);
        RecordBVHStatus.addRecording(builder, recording);
        return RecordBVHStatus.endRecordBVHStatus(builder);
    }
    unpack() {
        return new RecordBVHStatusT(this.recording());
    }
    unpackTo(_o) {
        _o.recording = this.recording();
    }
}
exports.RecordBVHStatus = RecordBVHStatus;
class RecordBVHStatusT {
    constructor(recording = false) {
        this.recording = recording;
    }
    pack(builder) {
        return RecordBVHStatus.createRecordBVHStatus(builder, this.recording);
    }
}
exports.RecordBVHStatusT = RecordBVHStatusT;
